var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkNotChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.5C0 0.671875 0.671875 0 1.5 0V1.5V13.7937L5.56563 10.8906C5.825 10.7031 6.17812 10.7031 6.4375 10.8906L10.5 13.7937V1.5H1.5V0H10.5C11.3281 0 12 0.671875 12 1.5V15.25C12 15.5312 11.8438 15.7875 11.5938 15.9156C11.3438 16.0437 11.0437 16.0219 10.8156 15.8594L6 12.4219L1.18438 15.8594C0.95625 16.0219 0.65625 16.0437 0.40625 15.9156C0.15625 15.7875 0 15.5312 0 15.25V1.5Z",
    fill: "#2D65F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkNotChecked);
export default __webpack_public_path__ + "static/media/bookmark_not_checked.f96b7dc4e060a84453fdfe77acf6401d.svg";
export { ForwardRef as ReactComponent };